// src/pages/TransferPendingRecord/components/TransferPendingRecordFilters.js
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../TransferPendingRecordSlice";
import { fetchTransferPendingRecord } from "../TransferPendingRecordThunk";
import { useDefaultDateRange } from "../../../hooks/useDefaultDateRange";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import RecordDateFilter from "../../../components/filters/RecordDateFilter";
import {
  fetchUsers,
  fetchBranchList,
} from "../../../store/commonThunks/lookups";
import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";

const TransferPendingRecordFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.transferPendingRecord);
  const lookups = useSelector((state) => state.lookups);

  useDefaultDateRange(setFilters, filters, "today");

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchBranchList());
  }, [dispatch]);

  useEffect(() => {
    if (
      filters.filterType &&
      filters.recordType &&
      filters.fromDate &&
      filters.toDate
    ) {
      handleReport();
    }
  }, [filters]);

  const handleFilterChange = (field, value) => {

    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    if (!filters.filterType) {
      messageApi.warning("Select Filter Type");
      return;
    }
    dispatch(
      fetchTransferPendingRecord({
        selectedFilterType: filters.filterType,
        selectedRecordType: filters.recordType,
        filters,
      })
    ).then((res) => {
      if (res.meta.requestStatus === "fulfilled")
        messageApi.success("Report loaded ✅");
      else messageApi.error("Failed to fetch records ❌");
    });
  };

  const renderExtraField = () => {
    switch (filters.filterType) {
      case "By Item":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Item</label>
            <SearchListAutoComplete
              entityType="item"
              optionsList={lookups.items.map((e) => ({
                sale_id: e.item_id,
                display_text: e.item_name,
              }))}
              onSelect={(obj) => handleFilterChange("itemId", obj?.sale_id)}
              placeholder="Item"
            />
          </Col>
        );
      case "By Branch":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>Search Branch</label>
            <SearchListAutoComplete
              entityType="location"
              optionsList={lookups?.branches?.message?.map((br) => ({
                sale_id: br?.id,
                display_text: br?.name,
              }))}
              onSelect={(obj) => handleFilterChange("branchId", obj?.sale_id)}
              placeholder="Location"
            />
          </Col>
        );

      case "By User":
        return (
          <Col xs={24} sm={12} md={8} xl={5}>
            <label>User</label>
            <SearchListAutoComplete
              entityType="user"
              optionsList={lookups?.users?.map((e) => ({
                sale_id: e.id,
                display_text: e.full_name,
              }))}
              onSelect={(obj) => handleFilterChange("userId", obj?.sale_id)}
              placeholder="User"
            />
          </Col>
        );
      default:
        return null;
    }
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row gutter={[16, 16]} wrap style={{ alignItems: "center" }}>
        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4} >
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "All", display_text: "All" },
              { sale_id: "By Branch", display_text: "By Branch" },
              { sale_id: "By User", display_text: "By User" },
            ]}
            value={{ value: filters.filterType, label: filters.filterType }}
            onSelect={(obj) => handleFilterChange("filterType", obj?.sale_id)}
            placeholder="Filter Type"
          />
        </Col>

        {renderExtraField()}

        <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={4} >
          <label>Record Type</label>
          <SearchListAutoComplete
            optionsList={[
              { sale_id: "with item", display_text: "With Item" },
              { sale_id: "without item", display_text: "Without Item" },
            ]}
            value={{ value: filters.recordType, label: filters.recordType }}
            onSelect={(obj) => handleFilterChange("recordType", obj?.sale_id)}
            placeholder="Record Type"
          />
        </Col>

        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
            handleFilterChange("fromDate", fromDate);
            handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24} sm={12} md={9} xl={3}
          style={{ paddingTop: "1.4rem" }}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            style={{height: 35.19}}
            block
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
    @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
    }
  `}</style>
    </Card>
  );
};

export default TransferPendingRecordFilters;
